"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var InfoPanel = /** @class */ (function (_super) {
    __extends(InfoPanel, _super);
    function InfoPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            anchorEl: null
        };
        return _this;
    }
    InfoPanel.prototype.render = function () {
        var _this = this;
        var anchorEl = this.state.anchorEl;
        var open = Boolean(anchorEl);
        var _a = this.props, size = _a.size, color = _a.color, infoText = _a.infoText;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.IconButton, { size: size || "small", onClick: function (evt) {
                    var currentTarget = evt.currentTarget;
                    _this.setState({ anchorEl: currentTarget });
                } },
                react_1.default.createElement(icons_1.InfoOutlined, { color: color || "secondary" })),
            react_1.default.createElement(core_1.Popover, { open: open, anchorEl: this.state.anchorEl, onClose: function () {
                    _this.setState({ anchorEl: null });
                }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                }, PaperProps: { style: { maxWidth: "50vw", padding: "8px" } } }, infoText)));
    };
    return InfoPanel;
}(react_1.default.Component));
exports.default = InfoPanel;
InfoPanel.propTypes = {
    infoText: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    size: prop_types_1.default.string,
    color: prop_types_1.default.string
};
